import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(public dialog: MatDialog) { }

  openConfirmDialog(msg) {
    return this.dialog.open(ConfirmDialogComponent, {
      width : '450px',
      panelClass: 'confirm-dialog-container',
      disableClose : true,
      data : {
        message : msg
      }
    });
  }

}
